import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { PostsState } from '@/store/types/posts.state';
import db from "@/firebase";
import Entry from "@/models/entry";

export const actions: ActionTree<PostsState, RootState> = {
    async fetchEntries({ commit, state }) {
        const entries: Entry[] = [];
        db.collection('landing-entries').onSnapshot((data) => {
            commit('setLoading', true);
            data.docs.map((item, i) => {
                entries[i] = new Entry();
                entries[i].name = item.data().name;
                entries[i].url = item.data().url;
                entries[i].imageURL = item.data().imageURL;
                entries[i].position = item.data().position;
                entries[i].description = item.data().description;
                entries[i].workInProgress = item.data().workInProgress;
            })
            entries.sort((a, b) => a.position - b.position);
            commit('setEntries', entries);
        });
    },
    async fetchData({ commit, dispatch }) {
        dispatch('fetchEntries');
    },
}